(function () {
    "use strict";

    /**
     * Generates an array with entries 1 to total
     * [1, ..., total]
     */
    angular.module("app").filter("range", Filter);

    function Filter() {
        return function (input, total) {
            total = parseInt(total);

            for (let i = 1; i <= total; i++) {
                input.push(i);
            }

            return input;
        };
    }
})();
